import { EATING_WAY_AREA_IMAGE_TYPE, IMAGE_SIZES } from 'utils';

export function getConfigImageSizeByAreaType(areaType: number) {
  let config: {
    minWidth: number;
    minHeight: number;
    maxWidth: number;
    maxHeight: number;
    maxFileSize: number;
  };
  switch (areaType) {
    case EATING_WAY_AREA_IMAGE_TYPE.TYPE1:
      config = IMAGE_SIZES.eating_way_img.full_size;
      break;
    case EATING_WAY_AREA_IMAGE_TYPE.TYPE2:
      config = IMAGE_SIZES.eating_way_img.w1_2_size;
      break;
    case EATING_WAY_AREA_IMAGE_TYPE.TYPE3:
      config = IMAGE_SIZES.eating_way_img.w2_3_size;
      break;
    case EATING_WAY_AREA_IMAGE_TYPE.TYPE4:
      config = IMAGE_SIZES.eating_way_img.w1_3_size;
      break;
    case EATING_WAY_AREA_IMAGE_TYPE.TYPE5:
      config = IMAGE_SIZES.eating_way_img.w1_2_h1_2_size;
      break;
    case EATING_WAY_AREA_IMAGE_TYPE.TYPE6:
      config = IMAGE_SIZES.eating_way_img.w1_3_h1_2_size;
      break;
    case EATING_WAY_AREA_IMAGE_TYPE.TYPE7:
      config = IMAGE_SIZES.eating_way_img.w1_4_h1_2_size;
      break;
    default:
      config = IMAGE_SIZES.eating_way_img.full_size;
  }

  return config;
}
